(function () {
  if (window.Shopify && Shopify.designMode) return;

  const initializedKey = '__pageTabsInitialized';
  let popstateBound = false;

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~\\':"!^$\[\]()=>|\/@])/g, '\\$1');
  }

  function preservePreviewParams(url) {
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb', 'pb_theme', 'preview_pathname'].forEach((key) => {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });

    return url;
  }

  function getMatchingLink(component, pathname) {
    const links = component.querySelectorAll('a.tab-button[data-page-tab-url]');

    return Array.from(links).find((link) => {
      try {
        const linkUrl = new URL(link.href, window.location.origin);
        return linkUrl.pathname === pathname;
      } catch (error) {
        return false;
      }
    });
  }

  function activateCurrentTab(component) {
    if (!component || typeof component.activateTab !== 'function') return;

    const activeLink =
      getMatchingLink(component, window.location.pathname) ||
      component.querySelector('.tab-button.active') ||
      component.querySelector('.tab-button[aria-selected="true"]') ||
      component.querySelector('.tab-button');

    if (activeLink) component.activateTab(activeLink);
  }

  async function loadPageTab(component, nextUrl, pushState) {
    const sectionId = component.dataset.sectionId;

    if (!sectionId) {
      window.location.assign(nextUrl.toString());
      return;
    }

    const sectionSelector = `#shopify-section-${escapeSelector(sectionId)}`;
    const currentSection = component.closest(sectionSelector) || component.closest('.shopify-section');

    if (!currentSection) {
      window.location.assign(nextUrl.toString());
      return;
    }

    component.classList.add('is-loading');
    component.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(nextUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = doc.querySelector(sectionSelector);

      if (!nextSection) throw new Error(`Section ${sectionId} was not found in the response.`);

      currentSection.outerHTML = nextSection.outerHTML;

      if (pushState) {
        history.pushState({ pageTabs: true }, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
      }

      if (doc.title) document.title = doc.title;

      const nextCanonical = doc.querySelector('link[rel="canonical"]');
      const currentCanonical = document.querySelector('link[rel="canonical"]');

      if (nextCanonical && currentCanonical) {
        currentCanonical.href = nextCanonical.href;
      }


      const insertedComponent = document.querySelector(`${sectionSelector} tabs-component[data-page-tabs="true"]`);
      if (insertedComponent) initializeComponent(insertedComponent);
    } catch (error) {
      console.error('Page tabs AJAX navigation failed:', error);
      window.location.assign(nextUrl.toString());
    }
  }

  function handleHeaderClick(event) {
    const link = event.target.closest('a.tab-button[data-page-tab-url]');
    if (!link) return;

    const component = link.closest('tabs-component[data-page-tabs="true"]');
    if (!component) return;

    const nextUrl = preservePreviewParams(new URL(link.href, window.location.origin));
    const currentUrl = new URL(window.location.href);

    event.preventDefault();
    event.stopImmediatePropagation();

    if (nextUrl.pathname === currentUrl.pathname && nextUrl.search === currentUrl.search) {
      activateCurrentTab(component);
      return;
    }

    loadPageTab(component, nextUrl, true);
  }

  function handleHeaderKeydown(event) {
    const link = event.target.closest('a.tab-button[data-page-tab-url]');
    if (!link) return;

    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar' && event.key !== 'Space') return;

    const component = link.closest('tabs-component[data-page-tabs="true"]');
    if (!component) return;

    const nextUrl = preservePreviewParams(new URL(link.href, window.location.origin));
    const currentUrl = new URL(window.location.href);

    event.preventDefault();
    event.stopImmediatePropagation();

    if (nextUrl.pathname === currentUrl.pathname && nextUrl.search === currentUrl.search) {
      activateCurrentTab(component);
      return;
    }

    loadPageTab(component, nextUrl, true);
  }

  function handlePopState() {
    document.querySelectorAll('tabs-component[data-page-tabs="true"]').forEach((component) => {
      const matchingLink = getMatchingLink(component, window.location.pathname);
      if (!matchingLink) return;

      const nextUrl = preservePreviewParams(new URL(window.location.href));
      loadPageTab(component, nextUrl, false);
    });
  }

  function initializeComponent(component) {
    if (!component || component[initializedKey]) return;

    const header = component.querySelector('.tabs-header');
    if (!header) return;

    activateCurrentTab(component);
    header.addEventListener('click', handleHeaderClick, true);
    header.addEventListener('keydown', handleHeaderKeydown, true);

    component[initializedKey] = true;

    if (!popstateBound) {
      window.addEventListener('popstate', handlePopState);
      popstateBound = true;
    }
  }

  function initialize(root) {
    root.querySelectorAll('tabs-component[data-page-tabs="true"]').forEach(initializeComponent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();